import React from 'react';

import AdminDeliveriesPage from '../../screens/AdminDeliveriesPage/AdminDeliveriesPage.component';

const AdminDeliveries: React.FC = () => <AdminDeliveriesPage />;

export default AdminDeliveries;
